import React, { useEffect, useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import CookieConsent from './CookieConsent';

const CookieConsentManager: React.FC = () => {
  const [showCookieConsent, setShowCookieConsent] = useState(false);
  const { currentUser } = useAuth();

  const handleAcceptCookies = () => {
    localStorage.setItem('cookie_consent_accepted', 'true');
    setShowCookieConsent(false);
  };

  useEffect(() => {
    // Only check when we have a user
    if (!currentUser) {
      setShowCookieConsent(false);
      return;
    }

    // Simple check - if we have consent stored, don't show the banner
    const hasConsented = localStorage.getItem('cookie_consent_accepted');
    setShowCookieConsent(!hasConsented);
  }, [currentUser]);

  if (!showCookieConsent) return null;

  return (
    <CookieConsent
      onAccept={handleAcceptCookies}
    />
  );
};

export default CookieConsentManager; 